import React from 'react'
import { AlertTriangle, Home, RotateCcw } from 'lucide-react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error('Uncaught error:', error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[60vh] flex items-center justify-center p-4">
          <div className="neu-panel max-w-lg w-full p-12 text-center relative overflow-hidden">
             <div className="absolute inset-0 bg-gradient-to-br from-hs-edge/10 to-transparent pointer-events-none"></div>
            
            <div className="w-20 h-20 neu-panel-inset rounded-full flex items-center justify-center mx-auto mb-8 border border-hs-edge/20">
               <AlertTriangle size={32} className="text-hs-edge drop-shadow-[0_0_10px_rgba(255,107,107,0.4)]" />
            </div>

            <h1 className="text-3xl font-display font-bold text-white mb-4 tracking-tighter">SOMETHING WENT WRONG</h1>
            <p className="text-hs-text mb-10 font-light leading-relaxed">
              An unexpected error occurred in the studio environment. Our team has been notified.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <button
                onClick={() => window.location.reload()}
                className="neu-button px-6 py-3 flex items-center justify-center text-xs font-mono font-bold text-white uppercase tracking-widest bg-hs-edge/20 border-hs-edge/30"
              >
                <RotateCcw size={14} className="mr-2" />
                Reload Studio
              </button>
              <a
                href="/"
                className="neu-button px-6 py-3 flex items-center justify-center text-xs font-mono font-bold text-hs-text hover:text-white uppercase tracking-widest"
              >
                <Home size={14} className="mr-2" />
                Back Home
              </a>
            </div>

            {process.env.NODE_ENV === 'development' && (
              <div className="mt-10 p-4 neu-panel-inset bg-black/40 text-left overflow-auto max-h-40 rounded-lg border-white/5">
                <p className="text-[10px] font-mono text-hs-edge uppercase mb-2 font-bold tracking-widest">Debug Info:</p>
                <code className="text-[10px] font-mono text-hs-text/70 break-all">
                  {this.state.error?.toString()}
                </code>
              </div>
            )}
          </div>
        </div>
      )
    }

    return this.props.children
  }
}

export default ErrorBoundary
